import { DefaultTooltip } from 'twyne-new.ui';

import PredefinedProperty from './Predefined';

export default function PredefinedGroupProperty({ options, unitOptions }) {
  return <>
    <div className='flex gap-1'>
      {options.map(({ label, className, components, name, ...props }) => <>
        <DefaultTooltip content={label} triggerProps={{ asChild: true }}>
          <div className={className}>
            <PredefinedProperty
              unitOptions={unitOptions}
              components={components}
              name={name}
              className='w-full flex gap-1'
              {...props}
            />
          </div>
        </DefaultTooltip>
      </>)}
    </div>
  </>
}
